module.exports = __webpack_public_path__ + "img/pasted image 4.69a07b4c.png";